/* Helpers compartilhados da Central de Relatórios de Produção. */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const PALETTE = ["#2B5EFF", "#FFC700", "#39D98A", "#FF5E5E", "#8B5CF6", "#0EA5E9", "#F97316", "#14B8A6", "#EC4899", "#84CC16"];

export function useChartTheme() {
  const read = () => document.documentElement.getAttribute("data-theme") === "dark";
  const [dark, setDark] = useState(read);
  useEffect(() => {
    const obs = new MutationObserver(() => setDark(read()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);
  return dark;
}

export function apexBase(dark) {
  return {
    chart: {
      background: "transparent",
      foreColor: dark ? "#8FA2C4" : "#52525b",
      toolbar: { show: false },
      fontFamily: "inherit",
      animations: { speed: 400 },
    },
    theme: { mode: dark ? "dark" : "light" },
    grid: { borderColor: dark ? "#1e2f4f" : "#e4e4e7" },
    tooltip: { theme: dark ? "dark" : "light" },
    dataLabels: { enabled: false },
    colors: PALETTE,
  };
}

export function buildParams(f) {
  const p = { date_from: f.date_from, date_to: f.date_to };
  const arr = (k) => { if (f[k]?.length) p[k] = f[k].join(","); };
  ["collaborators", "sectors", "postos", "statuses", "marketplaces", "stores", "states", "colors", "types"].forEach(arr);
  if (f.skus?.trim()) p.skus = f.skus.trim();
  if (f.cities?.trim()) p.cities = f.cities.trim();
  if (f.order_number?.trim()) p.order_number = f.order_number.trim();
  ["qty_min", "qty_max", "value_min", "value_max"].forEach((k) => {
    if (f[k] !== "" && f[k] !== null && f[k] !== undefined) p[k] = f[k];
  });
  return p;
}

export function fmtH(h) {
  const v = Number(h || 0);
  if (v >= 24) return `${Math.floor(v / 24)}d ${Math.round(v % 24)}h`;
  if (v >= 1) return `${v.toFixed(1)}h`;
  return `${Math.round(v * 60)}min`;
}

export async function downloadBlob(url, params, filename) {
  const res = await api.get(url, { params, responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

const todayLocal = () => new Date().toLocaleDateString("en-CA");
const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toLocaleDateString("en-CA");
};

export const PERIOD_PRESETS = [
  { key: "today", label: "Hoje", range: () => [todayLocal(), todayLocal()] },
  { key: "yesterday", label: "Ontem", range: () => [daysAgo(1), daysAgo(1)] },
  { key: "7d", label: "7 dias", range: () => [daysAgo(6), todayLocal()] },
  { key: "15d", label: "15 dias", range: () => [daysAgo(14), todayLocal()] },
  { key: "30d", label: "30 dias", range: () => [daysAgo(29), todayLocal()] },
  {
    key: "month", label: "Este mês",
    range: () => {
      const d = new Date();
      return [new Date(d.getFullYear(), d.getMonth(), 1).toLocaleDateString("en-CA"), todayLocal()];
    },
  },
  {
    key: "prev_month", label: "Mês anterior",
    range: () => {
      const d = new Date();
      const first = new Date(d.getFullYear(), d.getMonth() - 1, 1);
      const last = new Date(d.getFullYear(), d.getMonth(), 0);
      return [first.toLocaleDateString("en-CA"), last.toLocaleDateString("en-CA")];
    },
  },
  {
    key: "year", label: "Ano",
    range: () => [`${new Date().getFullYear()}-01-01`, todayLocal()],
  },
  { key: "custom", label: "Personalizado", range: null },
];
